import {EditarDocente as Matricula} from 'containers/Admin/EditarDocente'

export default function EditarDocente() {
  return (
    <Matricula />
  );
}
